import { render, staticRenderFns } from "./tabelFreeFood.vue?vue&type=template&id=0d7933ba"
import script from "./tabelFreeFood.vue?vue&type=script&lang=js"
export * from "./tabelFreeFood.vue?vue&type=script&lang=js"
import style0 from "./tabelFreeFood.vue?vue&type=style&index=0&id=0d7933ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports